"use client";

import posthog from "posthog-js";
import { PostHogProvider as PostHogProviderRaw } from "posthog-js/react";
import type { ReactNode } from "react";
import { keys } from "../keys";

export const analytics = posthog;

type PostHogProviderProps = {
	readonly children: ReactNode;
};

export const PostHogProvider = ({ children }: PostHogProviderProps) => (
	<PostHogProviderRaw
		apiKey={keys().NEXT_PUBLIC_POSTHOG_KEY}
		options={{
			api_host: "/ingest",
			ui_host: keys().NEXT_PUBLIC_POSTHOG_HOST,
			person_profiles: "identified_only",
			capture_pageview: true,
			capture_pageleave: true,
		}}
	>
		{children}
	</PostHogProviderRaw>
);
